export const getToday = () => new Date().toISOString().split("T")[0];

const DATE_ONLY = /^\d{4}-\d{2}-\d{2}$/;

// "Oct 5, 2026" for display. A date-only string ("2026-10-05", the
// dailyBreakdown key) is a calendar day, so it is formatted as that day:
// new Date("2026-10-05") is UTC midnight, which read in a US time zone is
// the evening before (QA: Account showed Oct 4 for videos watched Oct 5).
// A full timestamp is shown in the viewer's own time zone (or `timeZone`,
// which tests pass explicitly).
export const formatDisplayDate = (value, timeZone) => {
  if (!value) return "N/A";
  const date = new Date(value);
  if (isNaN(date)) return "N/A";
  const dateOnly = typeof value === "string" && DATE_ONLY.test(value);
  return new Intl.DateTimeFormat("en-US", {
    day: "numeric",
    month: "short",
    year: "numeric",
    timeZone: dateOnly ? "UTC" : timeZone,
  }).format(date);
};

// Coerce any value (null/undefined/strings from DDB, NaN from bad math) to a
// finite number. Returns 0 for anything that isn't finite so downstream
// formatters never produce "NaN" or "undefined" in the UI.
const toFiniteSeconds = (value) => {
  const n = Number(value);
  return Number.isFinite(n) ? n : 0;
};

export const formatTime = (totalSeconds) => {
  const n = toFiniteSeconds(totalSeconds);
  const sign = n < 0 ? "-" : "";
  const abs = Math.abs(n);
  const hours = Math.floor(abs / 3600);
  const minutes = Math.floor((abs % 3600) / 60);
  const seconds = Math.floor(abs % 60);
  return `${sign}${hours > 0 ? hours + "h " : ""}${minutes > 0 ? minutes + "m " : ""}${seconds}s`;
};

// Compact playback display: HH:MM:SS (when >= 1h) or MM:SS otherwise.
// Also used by the upload form to render a video's runtime.
export const formatPlaybackTime = (seconds) => {
  const n = toFiniteSeconds(seconds);
  const abs = Math.abs(n);
  const hrs = Math.floor(abs / 3600);
  const mins = Math.floor((abs % 3600) / 60);
  const secs = Math.floor(abs % 60);
  const sign = n < 0 ? "-" : "";
  if (hrs > 0)
    return `${sign}${hrs}:${mins.toString().padStart(2, "0")}:${secs.toString().padStart(2, "0")}`;
  return `${sign}${mins}:${secs.toString().padStart(2, "0")}`;
};
